export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const ADD_TO_BASKET = 'ADD_TO_BASKET';
export const GET_CHECKOUT_INFO = 'GET_CHECKOUT_INFO';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const APPLY_PROMO_CODE = 'APPLY_PROMO_CODE';
